import { useApiMutation } from "app/modules/api-client";

export const useAnnotationsMutations = () => {
    const createMutation = useApiMutation("Annotations", "annotationsCreate", {
        invalidateQueries: {
            Annotations: {
                annotationsList: true,
            },
        },
    });

    const deleteMutation = useApiMutation("Annotations", "annotationsDelete", {
        invalidateQueries: {
            Annotations: {
                annotationsList: true,
            },
        },
    });

    return {
        createAnnotation: createMutation,
        deleteAnnotation: deleteMutation,
    };
};
